<template>
  <footer class="page-footer landing_dark">
    <div class="container">
      <div class="row">
        <div class="col l6 m6 s12">
          <div class="white-text">
            &copy;
            2020
            <router-link to="/" class="white-text">Supersquares.co</router-link>
          </div>
        </div>
        <div class="col m1 l1 s12 white-text">
          About
        </div>
        <div class="col m1 l1 s12 white-text">
          F.A.Q.
        </div>
        <div class="col m1 l1 s12 white-text">
          <a href="mailto:support@supersquares.co" class='white-text'>Contact</a>
        </div>
      </div>
      <div class="row">
        <div class="col m3 s12">
          <a class="white-text" href="https://twitter.com/supersquaresco">
            <i class="fab fa-twitter fa-lg"> </i>
          </a>&nbsp;
          <a class="white-text" href="https://instagram.com/supersquares.co">
            <i class="fab fa-instagram fa-lg"> </i>
          </a>&nbsp;
          <a class="white-text" href="mailto:support@supersquares.co">
            <i class="fa fa-envelope fa-lg"> </i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style>
</style>
